这是常量编辑界面，直接应用即可实现功能模块的常量管理

<template>
  <div>
    <el-card shadow="never">
      <el-button type="primary" icon="el-icon-plus" size="mini" @click="add(0)"
        >添加</el-button
      >
    </el-card>
    <el-card shadow="never">
      <el-tree
        :data="tree"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
      >
        <span
          :class="'custom-tree-node ' + (node.isLeaf ? '' : 'custom-tree-root')"
          slot-scope="{ node, data }"
        >
          <span class="left">
            <span v-show="node.data.parentId == 0">
              {{ node.data.title }}
            </span>
            <span v-show="node.data.parentId == 0">[{{ node.data.code }}]</span>
            <span v-show="node.data.parentId != 0">
              <span class="zh">中文：{{ node.data.title }} ；</span>
              <span class="en" v-if="node.data.extraData"
                >英文：{{ node.data.extraData.en }}</span
              >
            </span>
          </span>
          <span v-show="node.isLeaf">{{ node.data.val }}</span>
          <span>
            <el-button
              size="mini"
              icon="el-icon-edit"
              @click="edit(data)"
              circle
            />
            <el-button
              size="mini"
              icon="el-icon-delete"
              @click="doDelete(data)"
              circle
            />
            <el-button
              size="mini"
              icon="el-icon-plus"
              v-show="!node.isLeaf || node.data.parentId == 0"
              @click="add(data.id)"
              circle
            />
          </span>
        </span>
      </el-tree>
    </el-card>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="editDialog"
      width="50%"
      append-to-body
    >
      <template v-if="editDialog">
        <cc-form
          :config="config"
          v-model="editObj"
          ref="editForm"
          :rules="rules"
          label-width="140px"
        ></cc-form>
        <el-button type="primary" size="mini" @click="doSubmit">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="editDialog2"
      width="50%"
      append-to-body
    >
      <template v-if="editDialog2">
        <cc-form
          :config="config2"
          v-model="editObj"
          ref="editForm2"
          :rules="rules2"
          label-width="140px"
        ></cc-form>
        <el-button type="primary" size="mini" @click="doSubmit2"
          >保存</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CcConstantAdmin",
  props: {
    apiSrc: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      editDialog: false,
      editDialog2: false,
      tree: [],
      editObj: {},
      title: "",
      config: {},
      rules: {
        title: [{ required: true, message: "请输入常量名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入Code", trigger: "blur" }],
        val: [{ required: true, message: "请输入值", trigger: "blur" }],
      },

      config2: {},
      rules2: {
        title: [{ required: true, message: "请输入中文", trigger: "blur" }],
        titleEn: [{ required: true, message: "请输入英文", trigger: "blur" }],
        code: [{ required: true, message: "请输入Code", trigger: "blur" }],
        val: [{ required: true, message: "请输入值", trigger: "blur" }],
      },
    };
  },
  methods: {
    getData() {
      let url = this.apiSrc + "getTree";
      this.ccRequest
        .do(url, {}, "GET")
        .then((res) => {
          this.tree = res.rows;
        })
        .catch((err) => {});
    },
    doDelete({ id }) {
      this.$confirm("确认删除？")
        .then((_) => {
          let url = this.apiSrc + "delete";
          this.ccRequest
            .do(url, { id: id }, "POST")
            .then((res) => {
              //刷新
              this.getData();
              done();
            })
            .catch((err) => {});
        })
        .catch((_) => {});
    },
    edit(e) {
      console.log(e);
      this.title = "编辑常量";
      this.editObj = { ...e, titleEn: "" };
      if (this.editObj.extraData && this.editObj.extraData.en) {
        this.editObj.titleEn = this.editObj.extraData.en;
      }
      if (e.parentId == 0) {
        this.editDialog = true;
        this.config = {
          api: this.apiSrc + "save",
          props: [
            {
              label: "常量名称",
              type: "input",
              name: "title",
            },
            {
              label: "Code",
              type: "input",
              name: "code",
              disabled: true,
            },
            {
              label: "值",
              type: "input",
              name: "val",
              disabled: true,
            },
          ],
        };
      } else {
        this.config2 = {
          api: this.apiSrc + "save",
          props: [
            {
              label: "中文",
              type: "input",
              name: "title",
            },
            {
              label: "英文",
              type: "input",
              name: "titleEn",
            },
            {
              label: "Code",
              type: "input",
              name: "code",
              disabled: true,
            },
            {
              label: "值",
              type: "input",
              name: "val",
              disabled: true,
            },
          ],
        };
        this.editDialog2 = true;
      }
    },
    add(parentId) {
      this.editObj = {
        parentId: parentId,
      };
      this.title = "新增常量";
      if (parentId == 0) {
        this.editDialog = true;
        this.config = {
          api: this.apiSrc + "save",
          props: [
            {
              label: "常量名称",
              type: "input",
              name: "title",
            },
            {
              label: "Code",
              type: "input",
              name: "code",
            },
            {
              label: "值",
              type: "input",
              name: "val",
            },
          ],
        };
      } else {
        this.config2 = {
          api: this.apiSrc + "save",
          props: [
            {
              label: "中文",
              type: "input",
              name: "title",
            },
            {
              label: "英文",
              type: "input",
              name: "titleEn",
            },
            {
              label: "Code",
              type: "input",
              name: "code",
            },
            {
              label: "值",
              type: "input",
              name: "val",
            },
          ],
        };
        this.editDialog2 = true;
      }
    },
    doSubmit() {
      this.$refs["editForm"]
        .validate()
        .then(() => {
          this.editObj.extraData = {};
          this.ccRequest
            .do("admin/dict/save", this.editObj, "POSTJSON")
            .then((res) => {
              this.editDialog = false;
              this.$message.success("保存成功");
              this.getData();
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },

    doSubmit2() {
      this.$refs["editForm2"]
        .validate()
        .then(() => {
          this.editObj.extraData = { en: this.editObj.titleEn };
          this.ccRequest
            .do("admin/dict/save", this.editObj, "POSTJSON")
            .then((res) => {
              this.editDialog2 = false;
              this.$message.success("保存成功");
              this.getData();
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
.left {
  width: 50%;
  text-align: left;
}
.zh {
  margin-right: 10px;
}
</style>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* text-align: center; */
  font-size: 14px;
  padding-right: 8px;
  height: 35px;
}

.custom-tree-root {
  font-weight: bold;
  border-bottom: 1px solid #ececec;
  padding-bottom: 5px;
}

.custom-tree-leaf {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 5px;
}

.el-tree-node__content.el-tree-node__content.el-tree-node__content {
  padding: 0px;
  height: 40px;
}
</style>
